import axios from 'axios';
import withDecrypt from '../../src/withDecrypt';

async function fetchAPI(query, { variables, preview } = {}) {
  return axios({
    method: 'post',
    url: process.env.NEXT_PUBLIC_API_URL,
    data: {
      query,
    },
    // headers: { 'accessToken': args[0] },
  })
    .then(resp => withDecrypt(resp.data))
    .catch(err => {
      console.log(err);
    });
}

export default async function _getTickerTextData(url, ticker) {
  const data = await fetchAPI(
    `{
      getTickerTextData(ticker: "${ticker}") {
        ticker
        halfCode
        seriesCode
        value
        recordDate
      }
    }`)
  return data
}
